if (typeof window.initProductMediaGallery !== "function") {
  window.initProductMediaGallery = function initProductMediaGallery(section) {
    const allowedSections = ["product-section", "featured-product-section"];

    if (
      !section ||
      !allowedSections.some((cls) => section.classList.contains(cls))
    ) {
      return;
    }

    // Teardown registry keyed on the section root so re-init and unload can
    // destroy every Swiper / observer / listener created for that section.
    const registerCleanup = (root, fn) => {
      (root._mediaGalleryCleanup = root._mediaGalleryCleanup || []).push(fn);
    };

    const teardown = (root) => {
      if (!root || !root._mediaGalleryCleanup) return;
      root._mediaGalleryCleanup.forEach((fn) => fn());
      root._mediaGalleryCleanup = [];
    };

    const initMainSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sliderEl = section.querySelector(".js-media-list");
      if (!sliderEl) return;

      const desktopType = sliderEl.dataset?.desktopType || "slider_previews";
      const mobileType = sliderEl.dataset?.mobileType || "slider_previews";
      const hasDesktopZoom = sliderEl.dataset?.hasDesktopZoom === "true";
      const buttonPrev = sliderEl.querySelector(".slider-nav-button--prev");
      const buttonNext = sliderEl.querySelector(".slider-nav-button--next");
      const paginationEl = sliderEl.querySelector(".slider-pagination");
      const mediaBox = sliderEl.closest(".product__media");
      const thumbsSlider = mediaBox?.querySelector(".js-media-sublist");
      // Drag-cursor navigation moves the zoom opener into a corner button, so
      // the media area itself stays draggable even with desktop zoom enabled.
      const hasDragCursorNav = !!mediaBox?.classList.contains(
        "product__media--desktop-nav-drag_cursor"
      );

      const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
      const speed = slideCount > 32 ? 0 : 800;

      // The desktop Slider type keeps the next slide in view as a peek: the
      // media column holds one full slide plus a half-width peek beside it.
      const hasDesktopPeek = desktopType === "slider";
      const desktopSlidesPerView = hasDesktopPeek ? 1.5 : 1;

      // Disable loop for large slide counts to reduce DOM overhead. The peek
      // also needs one whole slide more than it shows at once, so two media run
      // it as a bounded slider — looped, Swiper freezes the track instead.
      const minLoopSlides = hasDesktopPeek ? 3 : 2;
      const isLoop = slideCount >= minLoopSlides && slideCount <= 32;

      // On desktop slides sit flush in every gallery type except the two
      // "previews" ones, which are the only types the design spaces apart.
      const spaceFor = (type) =>
        type === "slider_previews" || type === "stacked_previews" ? 16 : 0;

      // Mobile runs one slide per view, so both slider types get the same
      // gutter between images. Grid lays its media out in CSS instead.
      const mobileSpace = mobileType === "grid" ? 0 : 16;

      const initSwiper = () => {
        const swiper = new Swiper(sliderEl, {
          slidesPerView: 1,
          spaceBetween: mobileSpace,
          autoHeight: false,
          loop: isLoop,
          direction: "horizontal",
          speed: speed,
          allowTouchMove: true,
          watchSlidesProgress: true,
          mousewheel: {
            forceToAxis: true,
          },
          navigation: {
            nextEl: buttonNext,
            prevEl: buttonPrev,
          },
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          breakpoints: {
            990: {
              slidesPerView: desktopSlidesPerView,
              allowTouchMove: hasDragCursorNav || !hasDesktopZoom,
              spaceBetween: spaceFor(desktopType),
            },
          },
          thumbs: {
            swiper: thumbsSlider?.swiper ? thumbsSlider.swiper : "",
            //autoScrollOffset: 1,
            multipleActiveThumbs: false,
            slideThumbActiveClass: "swiper-slide-thumb-active",
          },
          on: {
            slideChange: function () {
              window.pauseAllMedia(sliderEl);
              this.params.noSwiping = false;

              if (thumbsSlider?.swiper) {
                const activeIndex = isLoop ? this.realIndex : this.activeIndex;
                thumbsSlider.swiper.slideTo(activeIndex);
              }
            },
            slideChangeTransitionEnd: function () {
              const activeIndex = isLoop ? this.realIndex : this.activeIndex;
              const model3D =
                this.slides[activeIndex]?.querySelector("model-viewer");
              const posterBtn3D = this.slides[activeIndex]?.querySelector(
                ".shopify-model-viewer-ui__button--poster"
              );
              if (model3D && posterBtn3D) {
                posterBtn3D.removeAttribute("hidden");
              }
            },
            touchStart: function () {
              const activeIndex = isLoop ? this.realIndex : this.activeIndex;
              const model3D =
                this.slides[activeIndex]?.querySelector("model-viewer");
              if (model3D) {
                if (
                  !model3D.classList.contains(
                    "shopify-model-viewer-ui__disabled"
                  )
                ) {
                  this.params.noSwiping = true;
                  this.params.noSwipingClass = "swiper-slide";
                } else {
                  this.params.noSwiping = false;
                }
              }
            },
          },
        });

        // Drag-cursor navigation (Media gallery "Desktop slider navigation"
        // setting) — reuses the shared SliderDragCursor wiring from global.js.
        // The cursor lives in the media-list wrapper (outside the slider root),
        // so that wrapper is both the lookup scope and the tracking element.
        const cursorHost =
          sliderEl.closest(".product__media-list-wrapper") || section;
        if (
          typeof initCardSliderCursor === "function" &&
          cursorHost.querySelector(".js-section-card-cursor") &&
          !sliderEl._dragCursorDestroy
        ) {
          const destroyCursor = initCardSliderCursor(
            cursorHost,
            sliderEl,
            swiper
          );
          if (destroyCursor) {
            sliderEl._dragCursorDestroy = destroyCursor;
            registerCleanup(section, () => {
              if (sliderEl._dragCursorDestroy) {
                sliderEl._dragCursorDestroy();
                sliderEl._dragCursorDestroy = null;
              }
            });
          }
        }
      };

      const destroySwiper = () => {
        if (sliderEl._dragCursorDestroy) {
          sliderEl._dragCursorDestroy();
          sliderEl._dragCursorDestroy = null;
        }
        if (sliderEl.swiper) {
          sliderEl.swiper.destroy();
        }
        sliderEl.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
          wrapper.removeAttribute("style");
        });
        sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
          slide.removeAttribute("style");
        });
      };

      const hasDesktopSwiper =
        desktopType === "slider" || desktopType == "slider_previews";
      const hasMobileSwiper =
        mobileType === "slider" || mobileType == "slider_previews";

      let resizeObserver = null;
      if (hasDesktopSwiper && hasMobileSwiper) {
        initSwiper();
      } else {
        resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (window.innerWidth >= 990 && hasDesktopSwiper) {
              initSwiper();
              return;
            }

            if (window.innerWidth < 990 && hasMobileSwiper) {
              initSwiper();
              return;
            }

            destroySwiper();
          });
        });

        resizeObserver.observe(section);
      }

      registerCleanup(section, () => {
        if (resizeObserver) resizeObserver.disconnect();
        if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
      });
    };

    const initSubSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sliderEl = section.querySelector(".js-media-sublist");
      if (!sliderEl) return;

      const desktopType = sliderEl.dataset?.desktopType || "slider_previews";
      const mobileType = sliderEl.dataset?.mobileType || "slider_previews";
      // stacked_previews keeps the same vertical thumbs carousel on desktop;
      // the main list is a plain stacked column synced by initStackedPreviewsSync.
      const hasDesktopSwiper =
        desktopType === "slider_previews" || desktopType === "stacked_previews";
      const hasMobileSwiper = mobileType === "slider_previews";
      const isRtlPage = document.documentElement.dir === "rtl";
      // Both previews types run a bigger desktop thumb on a wider gap; the CSS
      // side of the pair is --product-thumb-gap.
      const desktopThumbGap =
        desktopType === "slider_previews" || desktopType === "stacked_previews"
          ? 24
          : 16;

      const initSwiper = () => {
        const thumbSlider = new Swiper(sliderEl, {
          spaceBetween: 16,
          slidesPerView: "auto",
          loop: false,
          direction: "horizontal",
          allowTouchMove: true,
          watchSlidesProgress: true,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          autoHeight: false,
          slideToClickedSlide: true,
          // The strip stops where it was dragged. Snapping is what made a short
          // drag roll back to the thumb it started from, which read as the strip
          // refusing to move; sticky is off for the same reason.
          freeMode: {
            enabled: true,
            sticky: false,
            momentumBounce: false,
          },
          on: {
            // Only a press that never travelled counts as a tap. The test
            // used to read `diff < range || diff > -range`, which is true for
            // every number — so any drag also re-enabled the click, and
            // slideToClickedSlide then pulled the strip back to whichever thumb
            // the finger happened to be over. That was the rollback.
            touchEnd: function (swiper) {
              const range = 5;
              const diff = (swiper.touches.diff = swiper.isHorizontal()
                ? swiper.touches.currentX - swiper.touches.startX
                : swiper.touches.currentY - swiper.touches.startY);
              if (Math.abs(diff) < range) swiper.allowClick = true;
            },
          },
          breakpoints: {
            576: {
              slidesPerView: "auto",
            },
            990: {
              slidesPerView: "auto",
              spaceBetween: desktopThumbGap,
              direction: "vertical",
              allowTouchMove: isRtlPage ? false : true,
            },
          },
        });

        return thumbSlider;
      };

      if (hasDesktopSwiper || hasMobileSwiper) {
        initSwiper();

        const resizeObserver = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            if (sliderEl.swiper) {
              if (window.innerWidth >= 990 && hasDesktopSwiper) {
                sliderEl.swiper.enable();
                sliderEl.swiper.changeDirection("vertical", true);
              }

              if (window.innerWidth < 990 && hasMobileSwiper) {
                sliderEl.swiper.enable();
                sliderEl.swiper.changeDirection("horizontal", true);
              }
            }
          });
        });

        resizeObserver.observe(section);

        registerCleanup(section, () => {
          resizeObserver.disconnect();
          if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
        });
      }
    };

    const initStackedPreviewsSync = (section) => {
      const mediaEl = section.querySelector(
        ".product__media--desktop-type-stacked_previews"
      );
      if (!mediaEl) return;

      const mediaList = mediaEl.querySelector(".product__media-list");
      const thumbs = Array.from(
        mediaEl.querySelectorAll(".product__media-subitem")
      );
      if (!mediaList || !thumbs.length) return;

      const setActiveThumb = (mediaId) => {
        let activeIndex = -1;
        thumbs.forEach((thumb, index) => {
          const isActive = thumb.dataset.mediaSubId === mediaId;
          thumb.classList.toggle("swiper-slide-thumb-active", isActive);
          if (isActive) activeIndex = index;
        });

        // The strip only holds about five thumbs at this size, so the marked
        // one has to be brought into view or the highlight sits off-screen.
        const thumbsSwiper = mediaEl.querySelector(".js-media-sublist")?.swiper;
        if (thumbsSwiper && activeIndex !== -1) {
          thumbsSwiper.slideTo(activeIndex);
        }
      };

      const onThumbClick = (event) => {
        if (window.innerWidth < 990) return;
        const mediaId = event.currentTarget.dataset.mediaSubId;
        const item = mediaList.querySelector(`[data-media-id="${mediaId}"]`);
        if (!item) return;

        const headerOffset =
          parseFloat(
            getComputedStyle(document.documentElement).getPropertyValue(
              "--header-height"
            )
          ) || 0;
        const top =
          item.getBoundingClientRect().top + window.scrollY - headerOffset - 24;
        window.scrollTo({ top, behavior: "smooth" });
        setActiveThumb(mediaId);
      };

      thumbs.forEach((thumb) => thumb.addEventListener("click", onThumbClick));

      // Scroll-spy: highlight the thumb of the media item near viewport center.
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setActiveThumb(entry.target.dataset.mediaId);
            }
          });
        },
        { rootMargin: "-40% 0px -55% 0px", threshold: 0 }
      );
      mediaList
        .querySelectorAll(".product__media-item")
        .forEach((item) => observer.observe(item));

      registerCleanup(section, () => {
        observer.disconnect();
        thumbs.forEach((thumb) =>
          thumb.removeEventListener("click", onThumbClick)
        );
      });
    };

    const initZoomSlider = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      const sectionBox =
        section.querySelector('[id^="MainProduct-"]') ||
        section.querySelector('[id^="FeaturedProduct-"]');
      const sectionId = sectionBox?.dataset?.section;
      const sliderEl = document.querySelector(
        `[data-section-id='${sectionId}'].js-popup-slider`
      );
      if (!sliderEl) return;

      const buttonPrev = sliderEl.querySelector(".slider-nav-button--prev");
      const buttonNext = sliderEl.querySelector(".slider-nav-button--next");

      const isLoop = sliderEl.querySelectorAll(".swiper-slide").length > 1;

      const onMainSliderToggleClick = (event) => {
        if (!sliderEl.swiper) return;
        const zoomToggle = event.target.closest(".product__media-toggle");
        if (!zoomToggle) return;
        const mediaId = zoomToggle.dataset?.mediaId;
        if (!mediaId) return;
        const slideIndex = sliderEl.swiper.slides.findIndex((slide) =>
          slide.querySelector(`[data-media-id="${mediaId}"]`)
        );
        if (slideIndex === -1) return;
        sliderEl.swiper.slideTo(slideIndex, 0);
        sliderEl.swiper.update();
      };

      new Swiper(sliderEl, {
        slidesPerView: 1,
        speed: 800,
        loop: isLoop,
        zoom: {
          maxRatio: 2,
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: buttonNext,
          prevEl: buttonPrev,
        },
        on: {
          afterInit: function () {
            section
              .querySelectorAll(".product__media-list .product__media-toggle")
              .forEach((elem) => {
                elem.addEventListener("click", onMainSliderToggleClick);
              });
          },
          slideChange: function () {
            window.pauseAllMedia(sliderEl);
            this.params.noSwiping = false;
            sliderEl.classList.remove("zoom");
          },
          touchMove: function () {
            sliderEl.classList.remove("zoom");
          },
          slideChangeTransitionEnd: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            const posterBtn3D = this.slides[activeIndex]?.querySelector(
              ".shopify-model-viewer-ui__button--poster"
            );
            if (model3D && posterBtn3D) {
              posterBtn3D.removeAttribute("hidden");
            }
          },
          touchStart: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            if (model3D) {
              if (
                !model3D.classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });

      registerCleanup(section, () => {
        section
          .querySelectorAll(".product__media-list .product__media-toggle")
          .forEach((elem) => {
            elem.removeEventListener("click", onMainSliderToggleClick);
          });
        if (sliderEl.swiper) sliderEl.swiper.destroy(true, true);
      });
    };

    const reinit = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }
      teardown(section);
      initSubSlider(section);
      initMainSlider(section);
      initStackedPreviewsSync(section);
      initZoomSlider(section);
    };

    reinit(section);

    if (!window.__themeProductMediaGalleryEvents) {
      window.__themeProductMediaGalleryEvents = true;

      document.addEventListener("shopify:section:load", (event) => {
        reinit(event.target);
      });

      document.addEventListener("shopify:section:unload", (event) => {
        teardown(event.target);
      });
    }
  };
}

if (typeof window.initProductPageElements !== "function") {
  window.initProductPageElements = function initProductPageElements(section) {
    const allowedSections = ["product-section", "featured-product-section"];

    if (
      !section ||
      !allowedSections.some((cls) => section.classList.contains(cls))
    ) {
      return;
    }

    // Teardown registry keyed on the section root so re-init and unload can
    // disconnect the sticky-bar observer created for that section.
    const registerCleanup = (root, fn) => {
      (root._pageElementsCleanup = root._pageElementsCleanup || []).push(fn);
    };

    const teardown = (root) => {
      if (!root || !root._pageElementsCleanup) return;
      root._pageElementsCleanup.forEach((fn) => fn());
      root._pageElementsCleanup = [];
    };

    const initProductAccordion = (section) => {
      if (
        !section ||
        !allowedSections.some((cls) => section.classList.contains(cls))
      ) {
        return;
      }

      section.querySelectorAll(".product-accordion").forEach((details) => {
        const summary = details.querySelector(".product-accordion__toggle");
        const content = details.querySelector(".product-accordion__content");
        let isAnimating = false;

        if (!summary || !content) return;
        if (details._accordionBound) return;
        details._accordionBound = true;

        // The whole card toggles: the padding around the header row used to
        // swallow clicks, leaving only the text line active. The button keeps
        // the semantics and the keyboard path, so a press on it is left alone
        // and everything else is forwarded to it — except the content, which is
        // copy the shopper may want to select or follow a link in.
        details.addEventListener("click", (event) => {
          if (event.target.closest(".product-accordion__toggle")) return;
          if (event.target.closest(".product-accordion__content")) return;
          if (event.target.closest("a, button, input, select, textarea"))
            return;
          summary.click();
        });

        summary.addEventListener("click", (event) => {
          if (isAnimating) return;

          event.preventDefault();

          isAnimating = true;

          if (!details.getAttribute("open")) {
            const contentHeight = content.scrollHeight;
            content.style.setProperty(
              "--product-accordion-max-height",
              `${contentHeight}px`
            );

            details.setAttribute("open", true);

            content.addEventListener(
              "transitionend",
              () => {
                isAnimating = false;
              },
              { once: true }
            );
          } else {
            details.removeAttribute("open");

            content.addEventListener(
              "transitionend",
              () => {
                isAnimating = false;
              },
              { once: true }
            );
          }
        });
      });
    };

    const initStickyAddBar = (section) => {
      if (!section || !section.classList.contains("product-section")) {
        return;
      }

      const buyButtons = section.querySelector(
        ".product__buy-buttons > product-form"
      );
      const stickyBar = section.querySelector(".product-sticky-add-bar");
      const footerEl =
        document.querySelector(
          ".shopify-section-group-footer-group .footer__bottom"
        ) ||
        document.querySelector(
          ".shopify-section-group-footer-group .footer__top"
        );

      if (!stickyBar) return;

      const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: 0.01,
      };

      const isElementBelowScroll = (element) => {
        return element ? element.getBoundingClientRect().top > 0 : false;
      };

      const toggleStickyBar = (isVisible) => {
        if (isVisible || isElementBelowScroll(buyButtons)) {
          stickyBar.classList.remove("active");
        } else {
          stickyBar.classList.add("active");
        }
      };

      const handleIntersect = (entries) => {
        const isVisible = entries.some((entry) => entry.isIntersecting);
        toggleStickyBar(isVisible);
      };

      const observer = new IntersectionObserver(
        handleIntersect,
        observerOptions
      );

      if (buyButtons) observer.observe(buyButtons);
      if (footerEl) observer.observe(footerEl);

      registerCleanup(section, () => observer.disconnect());
    };

    teardown(section);
    initStickyAddBar(section);
    initProductAccordion(section);

    if (!window.__themeProductPageElementsEvents) {
      window.__themeProductPageElementsEvents = true;

      document.addEventListener("shopify:section:load", (event) => {
        teardown(event.target);
        initStickyAddBar(event.target);
        if (!window.Shopify.designMode) {
          initProductAccordion(event.target);
        }
      });

      document.addEventListener("shopify:section:unload", (event) => {
        teardown(event.target);
      });
    }
  };
}

window.initProductMediaGallery(document.currentScript.parentElement);
window.initProductPageElements(document.currentScript.parentElement);
